import React from "react";
import {EditOutlined} from "@ant-design/icons";
import {
    PoolCard as StyledPoolCard,
    PoolCardContent,
    PoolInfo,
    PoolColorIndicator,
    EditButton,
    PoolCardTitle,
    PoolCardText
} from "./PoolsListModal.styles";

const PoolCard = ({
    pool,
    isSelected,
    onSelect,
    onEdit,
    hoveredPoolId,
    setHoveredPoolId,
    poolColor
}) => (
    <StyledPoolCard
        id={`pool-card-${pool._id}`}
        selected={isSelected}
        onClick={() => onSelect(pool)}
        onMouseEnter={() => setHoveredPoolId(pool._id)}
        onMouseLeave={() => setHoveredPoolId(null)}
    >
        <PoolCardContent align="center">
            <PoolInfo>
                <PoolColorIndicator hasH3Cells={pool.h3Cells?.length > 0} color={poolColor} />
                <div>
                    <PoolCardTitle level={5} selected={isSelected}>
                        {pool.name}
                    </PoolCardTitle>
                    <PoolCardText type="secondary">
                        H3 Hücre: {pool.h3Cells?.length || 0}
                    </PoolCardText>
                </div>
            </PoolInfo>
            <EditButton
                className="edit-button"
                type="text"
                icon={<EditOutlined />}
                size="small"
                visible={hoveredPoolId === pool._id}
                onClick={e => {
                    e.stopPropagation();
                    onEdit(pool._id);
                }}
            />
        </PoolCardContent>
    </StyledPoolCard>
);

export default PoolCard;
